(function () {
    'use strict';

    angular.module('imnApp').controller('OltRestoreBackupController', OltRestoreBackupController);

    OltRestoreBackupController.$inject = ['$scope', '$uibModalInstance', 'OltService', 'OltData', 'oltId', 'SystemConfigService'];

    function OltRestoreBackupController($scope, $uibModalInstance, OltService, OltData, oltId, SystemConfigService) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;

        var OLT_MODEL_INTELBRAS = 'Intelbras8820i';
        var MAX_UPLOAD_FILES_SIZE_BYTES = 209715200; // 200MB
        var INVALID_FILE_NAME_INTELBRAS_REGEX = /[^a-zA-Z0-9._\-]/; // Special
        // characters
        var INVALID_FILE_NAME_ZHONE_REGEX = /[^a-zA-Z0-9._\- ]/; // Special

        // Set the message in the modal according the OLT Model
        vm.description = is8820G() ? '8820G' : '8820i';

        // Method handler
        vm.close = close;

        // Method API
        vm.uploadFileName = uploadFileName;

        SystemConfigService.getSystemConfig().then(successGet).catch(errorGet);

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function uploadFileName() {
            vm.requestRunning = true;            
            if (vm.modelUpload.file && vm.modelUpload.file.size > 0) {
                var data = {
                    oltId: vm.modelUpload.oltId,
                    file: vm.modelUpload.file
                };
                OltService.restoreOltToFile(data).then(successUpload).catch(errorUpload);
            }else if (vm.modelUpload.fileName) {
                var data = {
                    oltId: vm.modelUpload.oltId,
                    fileName: vm.modelUpload.fileName
                };
                OltService.restoreOltToFileName(data).then(successUpload).catch(errorUpload);
            }else {
                errorUpload({status: 400, config: {}});
            }
        }

        function successUpload(data) {
            vm.requestRunning = false;
            OltService.successModalConstructor('loadFiles');
        }

        function errorUpload(response) {
            vm.requestRunning = false;
            OltService.errorModalConstructor(response, 'loadFiles');
        }

        function is8820G() {
            return OltData.detail.model != 'Intelbras8820i';
        }

        function initialize() {
            vm.modelUpload = {
                oltId: 0,
                oltName: '',
                fileName: ''
            };
            OltService.getFiles(oltId).then(sucessGetFiles).catch(errorGetFiles);
        }

        // Request Callbacks
        function sucessGetFiles(data) {
            vm.modelUpload = {
                oltId: data.oltId,
                oltName: data.oltName
            };
        }

        function errorGetFiles(response) {
            OltService.errorModalConstructor(response, 'getFiles');
            close();
        }

        function successGet(data) {
            vm.requestRunning = false;
            if (data) {
                vm.fromSIG = data.fromSig;
            }
        }

        function errorGet(response) {
            vm.requestRunning = false;
            SystemConfigService.errorModalConstructor(response, 'get');
        }

        /*
		function validateFiles(file) {
            console.log('validando');
            var invalidFileNameRegex = (vm.data.detail.model === OLT_MODEL_INTELBRAS) ? INVALID_FILE_NAME_INTELBRAS_REGEX : INVALID_FILE_NAME_ZHONE_REGEX;
            var totalFilesSize = 0;
            
            //for (var i = 0; i < files.length; ++i) {
                //var file = vm.files[i];
                var regexMatch = file.name.match(invalidFileNameRegex);
                if (regexMatch !== null) {
                    return false;
                }
                totalFilesSize += file.size;
            //}
            if (totalFilesSize > MAX_UPLOAD_FILES_SIZE_BYTES) {
                return false;
            }
            console.log('era pra ir');
            return true;
        }*/


        
    }
})();